import React from 'react'
import { upgradesEnabled } from '../../../lib/featureFlags'
import { useDashboard } from '../DashboardContext'
import { PlanPickerModal } from './PlanPickerModal'

export function PlanLimitBanner() {
  const { currentSubscription } = useDashboard()
  const [dismissed, setDismissed] = React.useState(false)
  const [planPickerOpen, setPlanPickerOpen] = React.useState(false)

  if (!currentSubscription || dismissed) return null

  const contactsUsed = currentSubscription.usage?.contactsUsed ?? 0
  const contactLimit = currentSubscription.usage?.contactLimit ?? -1
  if (contactLimit === -1 || contactsUsed / contactLimit < 0.8) return null

  const atLimit = contactsUsed >= contactLimit

  return (
    <>
      <div
        role="alert"
        style={{
          background: atLimit ? 'rgba(220,38,38,0.08)' : 'rgba(245,158,11,0.08)',
          border: `1px solid ${atLimit ? 'rgba(220,38,38,0.3)' : 'rgba(245,158,11,0.3)'}`,
          borderRadius: 8,
          padding: '10px 16px',
          marginBottom: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ fontSize: 13, color: 'var(--text)', flex: 1 }}>
          {atLimit
            ? `Contact limit reached — you've used ${contactsUsed.toLocaleString()} of ${contactLimit.toLocaleString()} contacts.`
            : `You've used ${contactsUsed.toLocaleString()} of ${contactLimit.toLocaleString()} contacts. Upgrade to keep growing.`}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
          <button
            onClick={() => upgradesEnabled && setPlanPickerOpen(true)}
            disabled={!upgradesEnabled || planPickerOpen}
            title={upgradesEnabled ? undefined : 'Upgrades not available yet'}
            style={{
              padding: '5px 14px',
              borderRadius: 6,
              border: 'none',
              background: atLimit ? '#dc2626' : '#d97706',
              color: '#fff',
              fontSize: 12,
              fontWeight: 600,
              cursor: upgradesEnabled ? 'pointer' : 'not-allowed',
              opacity: upgradesEnabled ? 1 : 0.5,
            }}
          >
            Upgrade
          </button>
          <button
            onClick={() => setDismissed(true)}
            aria-label="Dismiss"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 18,
              color: 'var(--text2)',
              lineHeight: 1,
              padding: '0 4px',
            }}
          >
            ×
          </button>
        </div>
      </div>
      {upgradesEnabled && planPickerOpen && <PlanPickerModal onClose={() => setPlanPickerOpen(false)} />}
    </>
  )
}
